export default function linkPiles(state = {}) {
    return state;
}
